import type { IconData } from '@stacksjs/iconify-core'

export const cr1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#0000b4\" d=\"M0 0h512v512H0z\"/><path fill=\"#fff\" d=\"M0 80.5h512v343.7H0z\"/><path fill=\"#d90000\" d=\"M0 168.2h512v168.2H0z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default cr1x1
